import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

export const DATE_FORMAT = 'MMM D, YYYY';

export const createDateWithTz = (date, tz = 'America/New_York') => {
  if (!date) {
    return dayjs();
  }
  return dayjs.tz(date, tz);
};

export const createNextChargeDate = (date, tz = 'America/New_York') => {
  if (!date) {
    return dayjs();
  }
  return dayjs.tz(`${date} 00:00:00`, tz);
};

export const getFormattedNextChargeDate = (date, tz = 'America/New_York') => {
  if (!date) {
    return '';
  }
  return dayjs.tz(`${date} 00:00:00`, tz).local().format(DATE_FORMAT);
};

export const getOffset = (timeZone = 'UTC', date = new Date()) => {
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
  return (tzDate.getTime() - utcDate.getTime()) / 6e4;
};

export const getOffsetInHours = (timeZone = 'UTC', date = new Date()) => {
  const offset = getOffset(timeZone, date);
  return offset / 60;
};

export const getActivationNewYorkTz = (date = new Date()) => {
  const timeZone = 'America/New_York';
  const offset = getOffsetInHours(timeZone, date);
  return `-0${Math.abs(offset)}:00`;
};

export const getThirtyDaysAgo = () => {
  let currentDate = new Date();
  let thirtyDaysAgo = new Date(currentDate);

  thirtyDaysAgo.setDate(currentDate.getDate() - 30);
  const year = thirtyDaysAgo.getFullYear();
  const month = String(thirtyDaysAgo.getMonth() + 1).padStart(2, '0');
  const day = String(thirtyDaysAgo.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

export const getScheduledCancellationDate = (nextChargeDate) => {
  return dayjs(nextChargeDate).subtract(1, 'day').format('MMM D');
};

export const formatIsoDateToReadable = (isoDate, tz = 'America/New_York') => {
  if (!isoDate) {
    return '';
  }
  return dayjs.tz(isoDate, tz).format(DATE_FORMAT);
};
export const formatDateToDay = (date) => {
  if (!date) {
    return;
  }
  const day = dayjs(date).date();

  const suffix =
    day >= 11 && day <= 13
      ? 'th'
      : day % 10 === 1
        ? 'st'
        : day % 10 === 2
          ? 'nd'
          : day % 10 === 3
            ? 'rd'
            : 'th';

  return `${day}${suffix}`;
};
